import { Box, Link, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import {
  allPartnersOnboardedEnabled,
  getFeatureToggle,
} from 'src/utils/feature-toggles'
import { isDppPool } from '~constants/pools'
import { useGetMe } from '~hooks/queries/me/use-get-me'
import { COLORS } from '~theme/colors'
import { PageWrapper } from '../page-wrapper'

const poolManagementEmail = 'poolmanagement@maersktankers.com'

export function DppPartnerHelpRibbon() {
  const { data: me } = useGetMe()

  const isPartnerWithDppPool =
    me !== undefined &&
    !me.isInternal &&
    (me.activePools ?? []).some((pool) => isDppPool(pool))

  if (!isPartnerWithDppPool || !getFeatureToggle(allPartnersOnboardedEnabled))
    return null

  return (
    <Box
      role="note"
      sx={{
        mt: 0.5,
        backgroundColor: COLORS.secondary.darkBlue,
        textAlign: 'center',
      }}
    >
      <PageWrapper sx={[{ py: 2, px: 2 }]}>
        <Typography variant="paragraph2" sx={{ color: COLORS.primary.white }}>
          Welcome to InSite! To help you get started, we recommend{' '}
          <Link component={RouterLink} to="/help">
            taking guided tours
          </Link>{' '}
          on the Help page. If you have any questions, please feel free to email
          us at{' '}
          <Link href={`mailto:${poolManagementEmail}`}>
            {poolManagementEmail}
          </Link>
          .
        </Typography>
      </PageWrapper>
    </Box>
  )
}
